import { RefBool } from "@tblabs/truffle";
import { Basket } from "../../../Services/Basket/Basket";
import { Box } from "../Utils/Box";
import { BasketOpenerButton } from "./BasketOpenerButton";
import { MenuButton } from "./MenuButton";
import { SearchButton } from "./SearchButton";
import { AuthButton } from "./AuthButton";


export class NavBarMenu extends Box
{
    constructor(_basket: Basket, showMenu: RefBool, showMiniBasket: RefBool)
    {
        super("navbar__right", [
            new SearchButton(),
            new BasketOpenerButton(_basket).OnClick(() => showMiniBasket.True()),
            new AuthButton(),
            new MenuButton().OnClick(() => showMenu.True()),
        ]);
    }
}
